module.exports = __webpack_public_path__ + "img/goods8_3.7d87bd6d.jpg";